import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PaginatedResponse, Voucher, VoucherCategory, VoucherFilters } from '@app/entity';
import { Observable } from 'rxjs/Observable';
import { API_VERSION } from '@app/core/api.version';
import { City } from '@app/entity/city';

// This service implements stocks, but in backend it names as voucher

@Injectable()
export class VouchersService {

  constructor(private http: HttpClient) { }

  createOrUpdateVoucher(data: Voucher): Observable<Voucher> {
    if (data.id) return this.http.patch<Voucher>(`/${API_VERSION}/vouchers/${data.id}/`, data);
    return this.http.post<Voucher>(`/${API_VERSION}/vouchers/`, data);
  }

  getVouchers(pageUrl?: string, filters?: VoucherFilters): Observable<PaginatedResponse<Voucher>> {
    let params = new HttpParams();
    if (filters && filters.author) params = params.set('author', filters.author + '');
    if (filters && filters.category) params = params.set('category', filters.category + '');
    if (filters && filters.page_size) params = params.set('page_size', filters.page_size + '');
    if (filters && filters.city) params = params.set('city', filters.city + '');
    if (filters && filters.exclude_outdated) params = params.set('exclude_outdated', filters.exclude_outdated + '');
    if (filters && filters.is_hidden != null) params = params.set('is_hidden', filters.is_hidden + '');
    return this.http.get<PaginatedResponse<Voucher>>(pageUrl || `/${API_VERSION}/vouchers/`, { params });
  }

  getVoucher(id?: number): Observable<Voucher> {
    if (!id) return Observable.of(null);
    return this.http.get<Voucher>(`/${API_VERSION}/vouchers/${id}/`);
  }

  getCategories(): Observable<VoucherCategory[]> {
    return this.http.get<VoucherCategory[]>(`/${API_VERSION}/voucher_categories/`);
  }

  getCities(): Observable<City[]> {
    return this.http.get<City[]>(`/${API_VERSION}/cities/`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/vouchers.service.ts